import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { usePageTitle } from "@/hooks/usePageTitle";
import { WorkforceBench } from "@/components/workforce/WorkforceBench";
import { BackButton } from "@/components/ui/BackButton";

const WorkforceBenchPage = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	usePageTitle(t("workforce.bench.title", "Bench Management"));

	return (
		<div className="w-full">
			<div className="flex justify-between items-center mb-6">
				<BackButton
					to="/workforce"
					label={t("workforce.backToList", "Back to Workforce")}
				/>
			</div>
			<PageHeader
				title={t("workforce.bench.title", "Bench Management")}
			/>

			<WorkforceBench />
		</div>
	);
};

export default WorkforceBenchPage;
